import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';

class CategoryFilter extends Component {
  render() {
    let { articleList, loadMore } = this.props;
    return(
      <div className="le-filtered-results">
        <Row className="le-filter-box">
          <Col md={12} >
            <span>INTERIOR</span>
            <span>CATEGORY 1</span>
            <span>CATEGORY 2</span>
          </Col>
        </Row>

        <Row className="le-filter-image-box">
          {
            articleList?articleList.map((data, index) => (
              
                <Col md={4} key={index}>
                  <a href={`/gallery/${data.permalink}`}>
                    <img src={data.images.thumbnail} alt={data.title} />
                    {/* <div className="summary">
                      <h5>{data.clientName}</h5>
                      <p>
                        {data.summary}
                      </p>
                    </div> */}
                  </a>
                </Col>
              
            )):null
          }
        </Row>

        {
          loadMore?(
            <Row className="le-filter-more-button">
              <Col md={12}>
                <a href="/gallery">View more work</a>
              </Col>
            </Row>
          ):null
        }
        
      </div>
    )
  }
}

export default CategoryFilter;